export default __webpack_public_path__ + "static/white-splitter-0a8ae9fc68c2205110cdbc64b9a578f1.png";